import React from 'react';

const Education = ({ education }) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-100">
      <div className="bg-purple-50 px-6 py-3 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Education</h3>
      </div>
      <div className="px-6 py-4">
        {education?.items && education.items.length > 0 ? (
          <div className="space-y-4">
            {education.items.map((edu, index) => (
              <div key={index} className="border-b border-gray-100 pb-3 last:border-b-0 last:pb-0">
                <h4 className="font-bold text-gray-800 mb-1">{edu.institution}</h4>
                <p className="text-sm text-gray-700 mb-1">{edu.degree}</p>
                <p className="text-xs text-purple-600 font-medium">{edu.duration}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 italic">No education listed</p>
        )}
      </div>
    </div>
  );
};

export default Education;
